import * as React from "react";

import { BetaIntroVideo } from "./components/BetaIntroVideo";

// The careers-page letter treatment: Sacramento cursive headline and signature over a 16/24 body.
const CURSIVE_FONT_FAMILY =
  'Sacramento, "Snell Roundhand", "Segoe Script", cursive';

const CURSIVE_FONT_URL =
  "https://fonts.googleapis.com/css2?family=Sacramento&display=swap";

export const AgentLaunchLetter: React.FC<{
  onFirstVideoPlay?: () => void;
}> = ({ onFirstVideoPlay }) => {
  return (
    <div className="flex flex-col gap-5 text-base leading-6 text-default">
      <link rel="stylesheet" href={CURSIVE_FONT_URL} />
      <h2
        className="m-0 font-normal text-default"
        style={{
          fontFamily: CURSIVE_FONT_FAMILY,
          fontSize: 44,
          lineHeight: 1.2,
        }}
      >
        Meet the new Replo
      </h2>
      <p className="m-0">Hi! I'm Yuxin, one of the co-founders of Replo.</p>
      <p className="m-0">
        We've spent the last year rebuilding Replo from the ground up. Our
        Shopify Theme Builder was used by over 20,000 brands to build
        high-converting landing pages, but our customers were asking for so much
        more.
      </p>
      <p className="m-0">
        Replo now builds your site, sets up your products, writes your copy,
        runs your ads, and tells you what's actually working, all in one place.
      </p>
      <BetaIntroVideo onFirstPlay={onFirstVideoPlay} />
      <p className="m-0">
        We're letting people in as a beta, and we'd love for you to be one of
        them. You'll get the new Replo, and me and the whole team a reply away
        while we shape it.
      </p>
      <p className="m-0">
        If it's not for you yet, no hard feelings. Press no thanks.
      </p>
      <p className="m-0">
        We're excited for you to give it a try! If you have any questions,
        please don't hesitate to reach out to us at support@replo.app
      </p>
      <div className="flex flex-col gap-1 pt-2">
        <p
          className="m-0 text-default"
          style={{
            fontFamily: CURSIVE_FONT_FAMILY,
            fontSize: 36,
            lineHeight: 1.1,
          }}
        >
          Yuxin and Noah
        </p>
        <p className="m-0 text-sm text-muted">Co-founders, Replo</p>
      </div>
    </div>
  );
};
